module.exports = __webpack_public_path__ + "Card-Example.png";